import { useDroppable } from "@dnd-kit/core";
import clsx from "clsx";
import styles from "./daycalendar.module.css";
import { CreateEventWrap } from "./CreateEventWrap";
import { useHistory } from "react-router-dom";
import { useCalendar } from "../../contexts/calendar/CalendarContext.context";
import { useMemo } from "react";
import { End } from "../../models/calendar/Calendar.model";
import { useModalEvent } from '../../contexts/calendar/ModalEventContext.context';


export type Props = {
    day: number;
    index: number;
    month: number;
    year: number;
    isLoad: boolean;
    view:string
};

function convertEndToString(end:End){
    return `${end.hour.toString().padStart(2,"0")}:${end.minute.toString().padStart(2,"0")} ${end.period.toLowerCase()}`;
}

export const DayCalendar = ({ day, month, year, index, view }: Props) => {
    const {calendar} = useCalendar();
    const currentDate =  new Date(year,month,day);
    const {setOptions} = useModalEvent();
    const { setNodeRef } = useDroppable({
        id: `${year}-${(month + 1).toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`,
    });
    const history = useHistory();

    const isToday =
        day === new Date().getDate() &&
        month === new Date().getMonth() &&
        year === new Date().getFullYear();
    const isAvaliable = useMemo(()=>{
        const date = new Date(year,month,day);
        const updateDay = date.getDay()<0?6:date.getDay()-1
        return (typeof calendar.availableWeekRules == "undefined")?Array(7).fill(true):calendar.availableWeekRules[updateDay];
    },[calendar.availableWeekRules,day,month,year]);
    
    const dayLimitInfo = useMemo(()=>{
        const date = new Date(year,month,day);
        const nday = (date.getDay()==0)?7:date.getDay()-1
        return (typeof calendar.weekAvailable == "undefined")?{numberDay:0,start:{hour:1,minute:2,period:"PM"} as End,end:{hour:1,minute:2,period:"PM"} as End}:calendar.weekAvailable.filter((day)=>day.numberDay==(nday))[0]
    },[calendar.weekAvailable,day,month,year]);

    const isMonth = useMemo(()=>(view=="month"),[view])

     const handleClickDay = () =>{
        //console.log('Se activo el hndle')
        setOptions((prev)=>({
            ...prev,
            isopen:true,
            numberOfWeek:currentDate.getDay(),
            day:day,
            month:month,
            year:year,
            id:'',
            isCreating:true,
            isEditing:false,
            isViewing:false
        }))
    }

    return (
        <div
            ref={setNodeRef}
            className={clsx(
                styles["calendar-day"],
                {
                    [styles["empty-day"]]: day === -1,
                    [styles["current-day"]]: isToday,
                    [styles["no-avaliable"]]: !isAvaliable
                }
            )}
        >
            {day > 0 && (
                <article className={clsx(styles["day-number"], "mx-3", styles["container-day-number"])}>
                    <div className={styles["header-button"]} title="Crear nuevo evento" onClick={handleClickDay}></div>
                    <span className={styles["btn-day-number"]} 
                    onClick={()=>history.push(`/calendar/day/${year}/${month+1}/${day}`)}>
                        {day}
                    </span>

                </article>
            )}
            {!isMonth&&isAvaliable&&dayLimitInfo&&<div className={styles["time-row"]}>
                <div className={styles["time-line"]}></div>
                <div className={styles["time-badge"]}>
                    {convertEndToString(dayLimitInfo.start)}
                </div>
            </div>}
            <CreateEventWrap day={day} index={index} month={month} year={year} view={view}/>
            {!isMonth&&isAvaliable&&dayLimitInfo&&<div className={styles["time-row"]}>
                <div className={styles["time-line"]}></div>
                <div className={styles["time-badge"]}>
                    {convertEndToString(dayLimitInfo.end)}
                </div>
            </div>}

        </div>
    );
};
